/**
Project: Voice Panel (c)
Title: Voice Setup Actions 
Description: Voice actions for create/modify voice regions
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import axios from "axios";
import { AppConfigProps } from "../../../../core/settings/app-config";
import {
  logMessage,
  checkIdentitySession,
  getSessionExpiredError,
} from "../../../../core/actions/common-actions";
import {
  VOICE_SETUP_PROGRESS_PAGE,
  VOICE_SETUP_PROGRESS_ACCOUNT_ID,
  VOICE_SETUP_PROGRESS_VOICE_REGIONS,
  VOICE_SETUP_DATA_RESET,
} from "../../../../store/voice-admin/constants";
const actionFileName = "voice-setup-actions.js";

// Set Voice Setup Progress Page to store
export function setVoiceSetupProgressPage(pageNumber) {
  return async function (dispatch) {
    try {
      dispatch({
        type: VOICE_SETUP_PROGRESS_PAGE,
        payload: pageNumber,
      });
    } catch (err) {
      throw Error(err);
    }
  };
}

// Set Voice Setup Progress Account Id to store
export function setVoiceSetupProgressAccountNumber(accountNumber) {
  return async function (dispatch) {
    try {
      dispatch({
        type: VOICE_SETUP_PROGRESS_ACCOUNT_ID,
        payload: accountNumber,
      });
    } catch (err) {
      throw Error(err);
    }
  };
}

// Get Voice  Regions for Setup
export function getVoiceRegions(cancelToken) {
  return new Promise(async function (resolve, reject) {
    let identitySession = checkIdentitySession();
    if (identitySession === true) {
      axios
        .get(AppConfigProps.serverRoutePrefix + "/voice-regions", cancelToken)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          if (axios.isCancel(err)) {
            logMessage(
              AppConfigProps.log.severityLevel.warning,
              actionFileName + ">getVoiceRegions()",
              AppConfigProps.httpStatusCode.clientClosedRequest,
              err.message
            );
          } else {
            reject(err.response);
          }
        });
    } else {
      reject(getSessionExpiredError());
    }
  });
}

export function setVoiceSetupProgressRegions(voiceRegions) {
  return async function (dispatch) {
    try {
      dispatch({
        type: VOICE_SETUP_PROGRESS_VOICE_REGIONS,
        payload: voiceRegions,
      });
    } catch (err) {
      throw Error(err);
    }
  };
}

export function addPstnUsage(data, cancelToken) {
  return new Promise(async function (resolve, reject) {
    let identitySession = checkIdentitySession();
    if (identitySession === true) {
      axios
        .post(
          AppConfigProps.serverRoutePrefix + "/pstn-usages",
          data,
          cancelToken
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          if (axios.isCancel(err)) {
            logMessage(
              AppConfigProps.log.severityLevel.warning,
              actionFileName + ">addPstnUsage()",
              AppConfigProps.httpStatusCode.clientClosedRequest,
              err.message
            );
          } else {
            reject(err.response);
          }
        });
    } else {
      reject(getSessionExpiredError());
    }
  });
}

export function addRoutingPolicy(data, cancelToken) {
  return new Promise(async function (resolve, reject) {
    let identitySession = checkIdentitySession();
    if (identitySession === true) {
      axios
        .post(
          AppConfigProps.serverRoutePrefix + "/routing-policies",
          data,
          cancelToken
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          if (axios.isCancel(err)) {
            logMessage(
              AppConfigProps.log.severityLevel.warning,
              actionFileName + ">addRoutingPolicy()",
              AppConfigProps.httpStatusCode.clientClosedRequest,
              err.message
            );
          } else {
            reject(err.response);
          }
        });
    } else {
      reject(getSessionExpiredError());
    }
  });
}

export function addVoiceRoute(data, cancelToken) {
  return new Promise(async function (resolve, reject) {
    let identitySession = checkIdentitySession();
    if (identitySession === true) {
      axios
        .post(
          AppConfigProps.serverRoutePrefix + "/voice-routes",
          data,
          cancelToken
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          if (axios.isCancel(err)) {
            logMessage(
              AppConfigProps.log.severityLevel.warning,
              actionFileName + ">addVoiceRoute()",
              AppConfigProps.httpStatusCode.clientClosedRequest,
              err.message
            );
          } else {
            reject(err.response);
          }
        });
    } else {
      reject(getSessionExpiredError());
    }
  });
}

export function resetVoiceSetupData() {
  return async function (dispatch) {
    try {
      dispatch({
        type: VOICE_SETUP_DATA_RESET,
      });
    } catch (err) {
      throw Error(err);
    }
  };
}

export function addVoiceDomains(data, cancelToken) {
  return new Promise(async function (resolve, reject) {
    let identitySession = checkIdentitySession();
    if (identitySession === true) {
      axios
        .post(
          AppConfigProps.serverRoutePrefix + "/voice-domains",
          data,
          cancelToken
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          if (axios.isCancel(err)) {
            logMessage(
              AppConfigProps.log.severityLevel.warning,
              actionFileName + ">addVoiceDomains()",
              AppConfigProps.httpStatusCode.clientClosedRequest,
              err.message
            );
          } else {
            reject(err.response);
          }
        });
    } else {
      reject(getSessionExpiredError());
    }
  });
}
